export default __webpack_public_path__ + "static/media/cover.7674e2c1.png";